module.exports = __webpack_public_path__ + "309d2357fb715702afdb16998e1c34d9.svg";